import { createTypeError } from './utils/create-error';
export function handleAnd(document, subQueries, evaluateDocumentFunction) {
    if (!Array.isArray(subQueries)) {
        createTypeError('$and expects an array of queries.');
    }
    return subQueries.every((q) => {
        if (typeof q !== 'object' || q === null)
            return false;
        return evaluateDocumentFunction(document, q);
    });
}
export function handleOr(document, subQueries, evaluateDocumentFunction) {
    if (!Array.isArray(subQueries)) {
        createTypeError('$or expects an array of queries.');
    }
    return subQueries.some((q) => {
        if (typeof q !== 'object' || q === null)
            return false;
        return evaluateDocumentFunction(document, q);
    });
}
